import { jsx as _jsx } from "react/jsx-runtime";
// Tremor Raw Tabs [v0.0.1]
import * as TabsPrimitives from "@radix-ui/react-tabs";
import React from "react";
import { cn } from "../../utils";
const Tabs = (props) => {
    return _jsx(TabsPrimitives.Root, { "tremor-id": "tremor-raw", ...props });
};
Tabs.displayName = "Tabs";
const TabsListVariantContext = React.createContext("line");
const variantStyles = {
    line: cn(
    // base
    "flex items-center justify-start border-b", 
    // border color
    "border-gray-4 dark:border-gray-800"),
    solid: cn(
    // base
    "inline-flex items-center justify-center rounded-md p-1", 
    // background color
    "bg-gray-3"),
};
const TabsList = React.forwardRef(({ className, variant = "line", children, ...props }, forwardedRef) => (_jsx(TabsPrimitives.List, { ref: forwardedRef, className: cn(variantStyles[variant], className), ...props, children: _jsx(TabsListVariantContext.Provider, { value: variant, children: children }) })));
TabsList.displayName = "TabsList";
function getVariantStyles(tabVariant) {
    switch (tabVariant) {
        case "line":
            return cn(
            // base
            "-mb-px items-center justify-center border-b-2 border-transparent px-4 py-2 transition-all", 
            // text
            "text-sm font-medium text-gray-9 whitespace-nowrap", 
            // hover
            "hover:text-gray-10 hover:border-gray-5", 
            // selected
            "data-[state=active]:border-primary-9 data-[state=active]:text-primary-9", 
            // disabled
            "data-[disabled]:pointer-events-none data-[disabled]:text-gray-8");
        case "solid":
            return cn(
            // base
            "inline-flex items-center justify-center  rounded px-3 py-1  ring-1 ring-inset transition-all", 
            // text
            "text-sm font-medium text-gray-10 whitespace-nowrap", 
            // ring
            "ring-transparent", 
            // selected
            "data-[state=active]:bg-white data-[state=active]:text-gray-900 data-[state=active]:shadow-md", 
            // disabled
            "data-[disabled]:pointer-events-none data-[disabled]:text-gray-8");
    }
}
const TabsTrigger = React.forwardRef(({ className, children, ...props }, forwardedRef) => {
    const variant = React.useContext(TabsListVariantContext);
    return (_jsx(TabsPrimitives.Trigger, { ref: forwardedRef, className: cn(getVariantStyles(variant), className), ...props, children: children }));
});
TabsTrigger.displayName = "TabsTrigger";
const TabsContent = React.forwardRef(({ className, ...props }, forwardedRef) => _jsx(TabsPrimitives.Content, { ref: forwardedRef, className: cn("outline-none", className), ...props }));
TabsContent.displayName = "TabsContent";
export { Tabs, TabsContent, TabsList, TabsTrigger };
export default Tabs;
